import {Injectable} from '@angular/core';
import {OptionsPricingGridComponentBase} from "../options-pricing-grid-base.component";
import {PricingGridLegDescriptor} from "../model/pricing-grid-leg.descriptor";
import {isVoid} from "../../utils";
import {PricingGridStrategy} from "../model/pricing-grid.strategy";

@Injectable()
export class OpgTestingService {

    constructor() {
    }

    run(comp: OptionsPricingGridComponentBase) {
        console.group('Testing OpgTestingService');

        this.getExpirationOffsetTests(comp);
        this.setExpirationOffsetTests(comp);

        console.groupEnd();
    }

    private getExpirationOffsetTests(comp: OptionsPricingGridComponentBase) {
        console.log('getExpirationOffset tests');

        // no expiration offset
        const leg1: PricingGridLegDescriptor = {
            type: 'leg', qty: 1, side: 'Buy'
        };
        const offset1 = comp.getExpirationOffset(leg1);
        console.assert(offset1 === undefined, 'Offset should be undefined for leg with no expiration date');

        // positive expiration offset
        const leg2: PricingGridLegDescriptor = {
            type: 'leg', qty: 1, side: 'Buy', expirationOffset: 3
        };
        const offset2 = comp.getExpirationOffset(leg2);
        console.assert(!isVoid(offset2), 'Offset should be defined for leg with expiration offset');
        console.assert(offset2 === '+3d', 'Offset should be show "+" sign for positive offset and "d" at the end');

        // negative expiration offset
        const leg3: PricingGridLegDescriptor = {
            type: 'leg', qty: 1, side: 'Buy', expirationOffset: -2
        };
        const offset3 = comp.getExpirationOffset(leg3);
        console.assert(!isVoid(offset3), 'Offset should be defined for leg with expiration offset');
        console.assert(offset3 === '-2d', 'Offset should be show "-" sign for negative offset and "d" at the end');

        // zero expiration offset
        const leg4: PricingGridLegDescriptor = {
            type: 'leg', qty: 1, side: 'Buy', expirationOffset: 0
        };
        const offset4 = comp.getExpirationOffset(leg4);
        console.assert(isVoid(offset4), 'Offset should be undefined for leg with zero expiration offset');
        console.assert(offset4 === undefined, 'Offset should be undefined for zero offset');

        // not valid number as offset
        const leg5: PricingGridLegDescriptor = {
            type: 'leg', qty: 1, side: 'Buy', expirationOffset: NaN
        };
        const offset5 = comp.getExpirationOffset(leg5);
        console.assert(isVoid(offset5), 'Offset should be undefined for leg with invalid expiration offset');
        console.assert(offset5 === undefined, 'Offset should be undefined for invalid offset');

        console.log('getExpirationOffset tests done');
    }

    private setExpirationOffsetTests(comp: OptionsPricingGridComponentBase) {
        console.log('setExpirationOffset tests');

        const gridSettings = {} as any;
        const targetSide = 'calls' as any;


        // set invalid offset should be ignored
        const strategy: PricingGridStrategy = new PricingGridStrategy(gridSettings, targetSide);
        const leg: PricingGridLegDescriptor = {
            type: 'leg', qty: 1, side: 'Buy', expirationOffset: 3
        };
        const offset = 'NaN';
        comp.setExpirationOffset(leg, {value: offset}, strategy);

        console.assert(leg.expirationOffset === 3, 'Expiration offset should not be changed for invalid offset');


        console.log('setExpirationOffset tests done');
    }
}